import { primaryButton as primaryButtonLegacy, secondaryButton as secondaryButtonLegacy, primaryFloatingButton as primaryFloatingButtonLegacy, secondaryFloatingButton as secondaryFloatingButtonLegacy, } from '../styles/ee';
import { combinators as combinatorsLegacy } from '../styles/legacy';
import { combinators as combinatorsCitron } from '../styles/citron';
import { primaryButton as primaryButtonCitron, secondaryButton as secondaryButtonCitron, primaryFloatingButton as primaryFloatingButtonCitron, secondaryFloatingButton as secondaryFloatingButtonCitron, } from '../styles/eeCitron';
import { citrusStyled } from '@citrus/runtime';
export var PrimaryButton = citrusStyled.button('PrimaryButton', { legacy: primaryButtonLegacy, citrus2022: primaryButtonCitron }, { combinators: { legacy: combinatorsLegacy, citrus2022: combinatorsCitron } });
export var PrimaryButtonAs = function (as) {
    return citrusStyled.as(as)('PrimaryButton', { legacy: primaryButtonLegacy, citrus2022: primaryButtonCitron }, { combinators: { legacy: combinatorsLegacy, citrus2022: combinatorsCitron } });
};
export var SecondaryButton = citrusStyled.button('SecondaryButton', { legacy: secondaryButtonLegacy, citrus2022: secondaryButtonCitron }, { combinators: { legacy: combinatorsLegacy, citrus2022: combinatorsCitron } });
export var SecondaryButtonAs = function (as) {
    return citrusStyled.as(as)('SecondaryButton', { legacy: secondaryButtonLegacy, citrus2022: secondaryButtonCitron }, { combinators: { legacy: combinatorsLegacy, citrus2022: combinatorsCitron } });
};
export var PrimaryFloatingButton = citrusStyled.button('PrimaryFloatingButton', {
    legacy: primaryFloatingButtonLegacy,
    citrus2022: primaryFloatingButtonCitron,
});
export var PrimaryFloatingButtonAs = function (as) {
    return citrusStyled.as(as)('PrimaryFloatingButton', {
        legacy: primaryFloatingButtonLegacy,
        citrus2022: primaryFloatingButtonCitron,
    });
};
export var SecondaryFloatingButton = citrusStyled.button('SecondaryFloatingButton', {
    legacy: secondaryFloatingButtonLegacy,
    citrus2022: secondaryFloatingButtonCitron,
});
export var SecondaryFloatingButtonAs = function (as) {
    return citrusStyled.as(as)('SecondaryFloatingButton', {
        legacy: secondaryFloatingButtonLegacy,
        citrus2022: secondaryFloatingButtonCitron,
    });
};
export var Styled = {
    PrimaryButton: PrimaryButton,
    PrimaryButtonAs: PrimaryButtonAs,
    SecondaryButton: SecondaryButton,
    SecondaryButtonAs: SecondaryButtonAs,
    PrimaryFloatingButton: PrimaryFloatingButton,
    PrimaryFloatingButtonAs: PrimaryFloatingButtonAs,
    SecondaryFloatingButton: SecondaryFloatingButton,
    SecondaryFloatingButtonAs: SecondaryFloatingButtonAs,
};
